import { render, staticRenderFns } from "./AddUserRole.vue?vue&type=template&id=d4a9f2ec&scoped=true&"
import script from "./AddUserRole.vue?vue&type=script&lang=js&"
export * from "./AddUserRole.vue?vue&type=script&lang=js&"
import style0 from "./AddUserRole.vue?vue&type=style&index=0&id=d4a9f2ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a9f2ec",
  null
  
)

export default component.exports